module.exports = __webpack_public_path__ + "img/2795712 (1).108b242d.svg";